<template>
    <v-card :loading="loading">
        <v-card-title>
            <span class="mr-2" v-text="title" />
            <a :href="frameSource" target="_blank">{{ frameSource }}</a>

            <v-spacer />
            <v-btn icon @click="$emit('close')">
                <v-fa-icon icon="times" />
            </v-btn>
        </v-card-title>

        <v-card-text>
            <iframe :src="frameSource" width="100%" height="600" frameborder="0" @load="loading = false" title="Page" />
        </v-card-text>
    </v-card>
</template>
<script>
export default {
    data() {
        return {
            loading: true,
        };
    },
    props: ["title", "frameSource"],
};
</script>
